import { Component, OnInit } from '@angular/core';
import { ITimeFrame, ITopicTagRates } from './topic-tag-rates';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ReportingDataService } from '../shared/reporting-data.service';
import { AppConfig } from 'src/app/app-config';
import { WithProcessing } from 'src/app/shared/mixins/with-processing';

class TopicTagRatesComponentBase {
  constructor() {}
}

const TopicTagRatesComponentMixinBase = WithProcessing(
  TopicTagRatesComponentBase,
);
@Component({
  selector: 'app-reporting-topic-tag-rates',
  templateUrl: './topic-tag-rates.component.html',
})
export class TopicTagRatesComponent
  extends TopicTagRatesComponentMixinBase
  implements OnInit
{
  displayedColumns: string[] = [
    'websiteName',
    'headlinesCount',
    'headlinesWithTopicsCount',
    'headlinesWithoutTopicsCount',
    'percentageTagged',
  ];
  dataSource: ITopicTagRates[];
  timeFrame: UntypedFormGroup;
  minDate = new Date(2020, 1, 17);

  constructor(
    private reportingDataService: ReportingDataService,
    private appConfig: AppConfig,
  ) {
    super();
  }

  ngOnInit(): void {
    const today = new Date();
    const previousWeek = new Date();
    previousWeek.setDate(
      today.getDate() - this.appConfig.topicTagRatesDayRange,
    );
    this.timeFrame = new UntypedFormGroup({
      dateFrom: new UntypedFormControl(previousWeek),
      dateTo: new UntypedFormControl(today),
    });
    this.loadTopicTagRates(this.timeFrame.value);
    this.timeFrame.valueChanges.subscribe((newTimeFrame: ITimeFrame) => {
      this.loadTopicTagRates(newTimeFrame);
    });
  }

  loadTopicTagRates(timeFrame?: ITimeFrame): void {
    this.dataSource = [];
    const getTopicTagRates$ =
      this.reportingDataService.getTopicTagRates(timeFrame);

    this.process$(getTopicTagRates$).subscribe((topicTagRates) => {
      this.dataSource = topicTagRates.sort(
        (a, b) => b.percentageTagged - a.percentageTagged,
      );
    });
  }
}
